/**
 * CR-8252 (decision 6): the renewal flag shown beside an approved supplier's
 * status in the Supplier Detail header.
 */
import { useEffect, useState } from 'react';
import { onboardingAPI } from '../../lib/api';
import { supplierRenewalFlag, type RenewalFlag } from '../../lib/renewalFlag';

/**
 * Loads the supplier's questionnaires and returns the worst renewal flag.
 *
 * @param supplierCompanyId - the supplier company
 * @param enabled - false skips the load (compliance off, or not approved)
 * @returns the flag, or null while loading, when nothing is due, or on error
 */
export function useSupplierRenewalFlag(supplierCompanyId: number | undefined, enabled: boolean): RenewalFlag | null {
  const [flag, setFlag] = useState<RenewalFlag | null>(null);

  useEffect(() => {
    setFlag(null);
    if (!enabled || !supplierCompanyId) return;
    let cancelled = false;
    onboardingAPI.getFilledDatasets({ supplier: supplierCompanyId, status: 'approved', page_size: 100 })
      .then((res) => { if (!cancelled) setFlag(supplierRenewalFlag(res.data.results || [])); })
      .catch((err: unknown) => console.error('Failed to load renewal status:', err));
    return () => { cancelled = true; };
  }, [supplierCompanyId, enabled]);

  return flag;
}
